import { render } from "./ObjectsNav.vue?vue&type=template&id=10463cae"
import script from "./ObjectsNav.vue?vue&type=script&lang=js"
export * from "./ObjectsNav.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2026.18.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__